import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Alert, Row, Col, Container, Card } from 'react-bootstrap';
import { REACT_APP_API_URL } from '../env';

const AdvanceBookingForm = () => {
  const [hotels, setHotels] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [formData, setFormData] = useState({
    purpose: '',
    otherPurpose: '',
    name: '',
    mobile: '',
    email: '',
    remarks: '',
    fromDate: '',
    toDate: '',
    hotelName: ''
  });

  const [message, setMessage] = useState({ type: '', text: '' });

  const today = new Date().toISOString().split('T')[0];

  // Simple sanitization function for text fields
  const sanitizeInput = (input) => {
    if (typeof input !== "string") return "";
    // Remove script tags and encode angle brackets
    return input.replace(/<script.*?>.*?<\/script>/gi, "")
                .replace(/[<>]/g, "");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Sanitize only text fields
    const sanitizedValue = ["name", "remarks", "otherPurpose", "purpose", "hotelName"].includes(name)
      ? sanitizeInput(value)
      : value;
    setFormData((prev) => ({ ...prev, [name]: sanitizedValue }));
  };

  const fetchBookings = async () => {
    try {
      const res = await axios.get(`${REACT_APP_API_URL}/api/dashboard/admin/advance-bookings`, {
        params: {
          mobile: formData.mobile,
          hotelName: formData.hotelName
        }
      });
      setBookings(res.data.data || []);
    } catch (error) {
      console.error('Error fetching bookings:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    // Additional validation for mobile and email
    if (!/^[0-9]{10}$/.test(formData.mobile)) {
      setMessage({ type: 'danger', text: 'Enter a valid 10-digit mobile number.' });
      return;
    }
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setMessage({ type: 'danger', text: 'Enter a valid email address.' });
      return;
    }
    // Prevent vague or short names/remarks
    if (formData.name.trim().length < 2) {
      setMessage({ type: 'danger', text: 'Name is too short.' });
      return;
    }
    if (formData.remarks && formData.remarks.trim().length > 0 && formData.remarks.trim().length < 5) {
      setMessage({ type: 'danger', text: 'Remarks are too short.' });
      return;
    }

    const payload = {
      name: sanitizeInput(formData.name),
      mobile: formData.mobile,
      email: formData.email,
      purpose: formData.purpose === 'Other' ? sanitizeInput(formData.otherPurpose) : sanitizeInput(formData.purpose),
      fromDate: formData.fromDate,
      toDate: formData.toDate,
      hotelName: sanitizeInput(formData.hotelName),
      remarks: sanitizeInput(formData.remarks)
    };

    try {
      const res = await axios.post(
        `${REACT_APP_API_URL}/api/hotel/advance-booking`,
        payload
      );

      if (res.status === 200) {
        setMessage({ type: 'success', text:`Booking successful! Ref: ${res.data?.data?.Ref || 'N/A'}` });
        setFormData({
          purpose: '',
          otherPurpose: '',
          name: '',
          mobile: '',
          email: '',
          remarks: '',
          fromDate: '',
          toDate: '',
          hotelName: ''
        });
        fetchBookings();
      } else {
        setMessage({ type: 'danger', text: 'Booking failed!' });
      }
    } catch (error) {
      console.error('Booking error:', error);
      setMessage({
        type: 'danger',
        text: error.response?.data?.message || 'Something went wrong!'
      });
    }
  };

  useEffect(() => {
    const fetchHotels = async () => {
      try {
        const res = await axios.get(`${REACT_APP_API_URL}/api/room-tariff/get-hotels`);
        const hotelList = res.data.data.map((hotel) => ({
          value: hotel.UnitName,
          label: hotel.UnitName
        }));
        setHotels(hotelList);
      } catch (error) {
        console.error('Error fetching hotels:', error);
      }
    };

    fetchHotels();
  }, []);

  return (
    <>
     
      <style>{`
        .slim-input {
          height: 38px !important;
          font-size: 14px !important;
          padding: 6px 10px !important;
          border-radius: 6px !important;
        }
        .slim-button {
          font-size: 14px !important;
          border-radius: 25px !important;
          font-weight: 600;
        }
      `}</style>

      <section
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{
          height: '30vh',
          backgroundImage: "url('/images/unsplash1.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: 'white',
          padding: '40px 10px'
        }}
      >
        <h1
          style={{
            fontSize: 'clamp(28px, 5vw, 42px)',
            fontWeight: 'bold',
            color: 'white'
          }}
        >
          Bulk/Shaadi Package Booking
        </h1>
      </section>

      <Container className="py-5">
        <Card className="shadow rounded-4 border-0 p-4">
          <h4 className="text-center mb-4">Fill in the details below</h4>

          {message.text && (
            <Alert variant={message.type} className="text-center">
              {message.text}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Purpose <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select className="slim-input" name="purpose" value={formData.purpose} onChange={handleChange} required>
                    <option value="">-- Select Purpose --</option>
                    <option value="Marriage">Marriage</option>
                    <option value="Birthday Party">Birthday Party</option>
                    <option value="Corporate Function">Corporate Function</option>
                    <option value="Other">Other</option>
                  </Form.Select>
                </Form.Group>

                {formData.purpose === 'Other' && (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Specify Other Purpose <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      className="slim-input"
                      name="otherPurpose"
                      value={formData.otherPurpose}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                )}

                <Form.Group className="mb-3">
                  <Form.Label>
                    From Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="slim-input"
                    name="fromDate"
                    value={formData.fromDate}
                    onChange={handleChange}
                    required
                    min={today}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Guest Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                     placeholder="Enter full name"
                    className="slim-input"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                     placeholder="Enter email address"
                    className="slim-input"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Hotel Name <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    className="slim-input"
                    name="hotelName"
                    value={formData.hotelName}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Hotel --</option>
                    {hotels.map((hotel) => (
                      <option key={hotel.value} value={hotel.value}>
                        {hotel.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    To Date <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="date"
                    className="slim-input"
                    name="toDate"
                    value={formData.toDate}
                    onChange={handleChange}
                    required
                    min={formData.fromDate || today}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    Mobile Number <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    className="slim-input"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                    maxLength={10}
                    pattern="[0-9]{10}"
                    placeholder="Enter 10-digit mobile number"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Remarks</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    className="slim-input"
                    name="remarks"
                    value={formData.remarks}
                    onChange={handleChange}
                    placeholder="Enter any additional remarks"
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="text-center pt-2">
              <Button
                type="submit"
                className="px-4 py-2 slim-button"
                style={{
                  backgroundColor: "#007bff",
                  borderColor: "#007bff"
                }}
              >
                Submit Request
              </Button>
            </div>
          </Form>
        </Card>
      </Container>
    </>
  );
};

export default AdvanceBookingForm;